export function loadGoogleAnalytics() {
  if (typeof window === 'undefined' || window.gtag) {
    return;
  }

  try {
    const googleScript = document.createElement('script');
    googleScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${process.env.VUE_APP_GA_ID}`);
    googleScript.async = true;
    document.head.appendChild(googleScript);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', process.env.VUE_APP_GA_ID);
  } catch (error) {
    console.error('Erro ao carregar Google Analytics:', error);
  }
}

function normalizeValues(obj) {
  const normalized = { ...obj };
  Object.entries(normalized).forEach(([key, value]) => {
    if (value === null || value === '' || value === undefined) {
      normalized[key] = 0;
    }
  });
  
  return normalized;
}

export function sendGAEvent(event, obj) {
  loadGoogleAnalytics();
  const normalizedObj = normalizeValues(obj);
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', event, normalizedObj);
  }
}